// import React, { useState, useEffect, useCallback } from 'react';
// import { Button, ButtonGroup, Form, Modal } from 'react-bootstrap';
// import { FaSpinner, FaSync, FaWhatsapp, FaChevronLeft, FaChevronRight, FaEdit } from 'react-icons/fa';
// import {
//   BarChart, Bar, Line, PieChart, Pie, Cell,
//   XAxis, YAxis, CartesianGrid, Tooltip, Legend,
//   ResponsiveContainer, ComposedChart
// } from 'recharts';
// import { toast } from 'react-toastify';
// import '../../responsive.css';
// import api from '../../services/api';

// // ==========================================
// // TEMPLATE PADRÃO
// // ==========================================
// const TEMPLATE_PADRAO = `Olá, \${CLIENTE}. Tudo bem com você? Segue o link do boleto da \${EMPRESA} com o vencimento para \${VENCIMENTO}. Caso já tenha pago, desconsidere essa mensagem.
// Link: \${LINK_BOLETO}
// Se preferir fazer o PIX, essa é nossa chave: SEU_PIX_AQUI`;

// const STORAGE_KEY = 'whatsapp_template';

// // ==========================================
// // SKELETON LOADING COMPONENTS
// // ==========================================
// const SkeletonCard = () => (
//   <div className="stat-card">
//     <div className="placeholder-glow">
//       <span className="placeholder col-7 mb-2 d-block" style={{ height: '14px', borderRadius: '4px' }}></span>
//       <span className="placeholder col-10 d-block" style={{ height: '32px', borderRadius: '4px' }}></span>
//     </div>
//   </div>
// );

// const SkeletonChart = () => (
//   <div className="placeholder-glow p-3" style={{ height: '300px', display: 'flex', alignItems: 'flex-end', gap: '12px' }}>
//     {[40, 70, 55, 90, 65, 80, 45, 75, 60, 85, 50, 95].map((h, i) => (
//       <span key={i} className="placeholder flex-fill" style={{ height: `${h}%`, borderRadius: '4px 4px 0 0' }}></span>
//     ))}
//   </div>
// );

// const SkeletonTable = () => (
//   <div className="placeholder-glow">
//     {[1, 2, 3, 4, 5].map(i => (
//       <div key={i} className="d-flex gap-3 mb-3">
//         <span className="placeholder col-4" style={{ height: '18px', borderRadius: '4px' }}></span>
//         <span className="placeholder col-2" style={{ height: '18px', borderRadius: '4px' }}></span>
//         <span className="placeholder col-2" style={{ height: '18px', borderRadius: '4px' }}></span>
//         <span className="placeholder col-2" style={{ height: '18px', borderRadius: '4px' }}></span>
//       </div>
//     ))}
//   </div>
// );

// // ==========================================
// // MODAL: EDITAR TEMPLATE
// // ==========================================
// const ModalEditarTemplate = ({ show, onClose, template, onSalvar }) => {
//   const [texto, setTexto] = useState(template);

//   useEffect(() => {
//     setTexto(template);
//   }, [template]);

//   const handleSalvar = () => {
//     onSalvar(texto);
//     onClose();
//     toast.success('Template salvo com sucesso!');
//   };

//   const handleRestaurar = () => {
//     setTexto(TEMPLATE_PADRAO);
//   };

//   return (
//     <Modal show={show} onHide={onClose} size="lg" centered>
//       <Modal.Header closeButton>
//         <Modal.Title>Editar Template</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>

//         {/* Bloco de instruções */}
//         <div className="alert alert-info mb-3" style={{ borderLeft: '4px solid #4361ee', borderRadius: '6px' }}>
//           <strong>Importante!</strong>
//           <ul className="mb-0 mt-2">
//             <li><code>{'${CLIENTE}'}</code> — nome do cliente</li>
//             <li><code>{'${VENCIMENTO}'}</code> — vencimento da parcela</li>
//             <li><code>{'${PARCELA}'}</code> — ex: "02 de 12"</li>
//             <li><code>{'${VALOR}'}</code> — valor da parcela</li>
//             <li><code>{'${EMPRESA}'}</code> — nome da sua empresa</li>
//             <li><code>{'${LINK_BOLETO}'}</code> — link do boleto</li>
//           </ul>
//         </div>

//         <Form.Group>
//           <Form.Label className="fw-bold">Mensagem</Form.Label>
//           <Form.Control
//             as="textarea"
//             rows={8}
//             value={texto}
//             onChange={(e) => setTexto(e.target.value)}
//             placeholder="Digite o template da mensagem..."
//           />
//           <Form.Text className="text-muted">{texto.length}/600</Form.Text>
//         </Form.Group>
//       </Modal.Body>
//       <Modal.Footer className="justify-content-between">
//         <Button variant="outline-secondary" onClick={handleRestaurar}>
//           Restaurar padrão
//         </Button>
//         <div className="d-flex gap-2">
//           <Button variant="outline-dark" onClick={onClose}>Fechar</Button>
//           <Button variant="success" onClick={handleSalvar}>Salvar</Button>
//         </div>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// // ==========================================
// // MODAL: ENVIAR WHATSAPP
// // ==========================================
// const ModalWhatsApp = ({ show, onClose, parcela, template, onAbrirTemplate, formatarData, formatarMoeda }) => {
//   const [telefone, setTelefone] = useState('');
//   const [mensagem, setMensagem] = useState('');

//   // Substitui as variáveis do template pelos dados reais da parcela
//   const gerarMensagem = useCallback((tpl) => {
//     const nomeEmpresa = localStorage.getItem('empresa_nome') || 'nossa empresa';

//     return tpl
//       .replace(/\${CLIENTE}/g,    parcela?.customerName   || '')
//       .replace(/\${VENCIMENTO}/g, parcela?.dueDate
//         ? new Date(parcela.dueDate).toLocaleDateString('pt-BR', { timeZone: 'UTC' })
//         : '')
//       .replace(/\${PARCELA}/g,    parcela?.installmentNumber
//         ? `${String(parcela.installmentNumber).padStart(2, '0')} de ${String(parcela.totalInstallments || '?').padStart(2, '0')}`
//         : '')
//       .replace(/\${VALOR}/g,      parcela?.amount
//         ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(parcela.amount)
//         : '')
//       .replace(/\${EMPRESA}/g,    nomeEmpresa)
//       .replace(/\${LINK_BOLETO}/g, parcela?.boletoUrl || '');
//   }, [parcela]);

//   useEffect(() => {
//     if (parcela) {
//       // Formata o telefone automaticamente
//       const num = (parcela.phone || '').replace(/\D/g, '');
//       setTelefone(num.startsWith('55') ? num : `55${num}`);
//       setMensagem(gerarMensagem(template));
//     }
//   }, [parcela, template, gerarMensagem]);

//   const handleEnviar = () => {
//     if (!telefone) {
//       toast.warning('Informe o telefone!');
//       return;
//     }
//     const url = `https://wa.me/${telefone}?text=${encodeURIComponent(mensagem)}`;
//     window.open(url, '_blank');
//     onClose();
//   };

//   return (
//     <Modal show={show} onHide={onClose} centered>
//       <Modal.Header closeButton>
//         <Modal.Title>
//           <FaWhatsapp className="me-2 text-success" />
//           Enviar boleto via WhatsApp
//         </Modal.Title>
//       </Modal.Header>
//       <Modal.Body>

//         {/* Info da parcela */}
//         {parcela && (
//           <div className="mb-3 p-2 bg-light rounded">
//             <div>
//               <strong>Conta:</strong>{' '}
//               <span className="text-danger">{parcela.orderDescription || parcela.customerName}</span>
//             </div>
//             <div>
//               <strong>Parcela:</strong>{' '}
//               <span className="text-danger">
//                 {String(parcela.installmentNumber || '').padStart(2, '0')} de{' '}
//                 {String(parcela.totalInstallments || '?').padStart(2, '0')}
//               </span>
//             </div>
//           </div>
//         )}

//         {/* Telefone */}
//         <Form.Group className="mb-3">
//           <Form.Label className="fw-bold">Telefone:</Form.Label>
//           <div className="input-group">
//             <span className="input-group-text text-success">
//               <FaWhatsapp />
//             </span>
//             <Form.Control
//               type="text"
//               value={telefone}
//               onChange={(e) => setTelefone(e.target.value.replace(/\D/g, ''))}
//               placeholder="5588999999999"
//             />
//           </div>
//         </Form.Group>

//         {/* Mensagem */}
//         <Form.Group>
//           <Form.Label className="fw-bold">Mensagem:</Form.Label>
//           <Form.Control
//             as="textarea"
//             rows={7}
//             value={mensagem}
//             onChange={(e) => setMensagem(e.target.value)}
//           />
//           <Form.Text className="text-muted">{mensagem.length}/600</Form.Text>
//         </Form.Group>
//       </Modal.Body>
//       <Modal.Footer className="justify-content-between">
//         {/* Botão para abrir o editor de template */}
//         <Button variant="dark" onClick={onAbrirTemplate}>
//           <FaEdit className="me-1" /> Template
//         </Button>
//         <div className="d-flex gap-2">
//           <Button variant="outline-dark" onClick={onClose}>Fechar</Button>
//           <Button variant="success" onClick={handleEnviar}>
//             <FaWhatsapp className="me-1" /> Enviar
//           </Button>
//         </div>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// // ==========================================
// // COMPONENTE PRINCIPAL
// // ==========================================
// const Dashboard = () => {
//   const anoAtual = new Date().getFullYear();

//   const [windowWidth, setWindowWidth]       = useState(window.innerWidth);
//   const [loading, setLoading]               = useState(true);
//   const [error, setError]                   = useState('');
//   const [periodoGrafico, setPeriodoGrafico] = useState(6);
//   const [anoSelecionado, setAnoSelecionado] = useState(anoAtual);

//   const [dashboardData, setDashboardData] = useState({
//     cards: { saldo: 0, faturamentoMes: 0, clientesAtivos: 0, anunciosAtivos: 0 },
//     charts: { monthlyEvolution: [], financialControl: [], planDistribution: [] },
//     table: { installments: [] }
//   });

//   const [filtroVencimento, setFiltroVencimento]     = useState('vencidos');
//   const [diasPersonalizados, setDiasPersonalizados] = useState(7);

//   // ── Estados dos Modais ──
//   const [parcelaSelecionada, setParcelaSelecionada]       = useState(null);
//   const [showModalWhatsApp, setShowModalWhatsApp]         = useState(false);
//   const [showModalTemplate, setShowModalTemplate]         = useState(false);

//   // ── Template (persiste no localStorage) ──
//   const [template, setTemplate] = useState(() => {
//     return localStorage.getItem(STORAGE_KEY) || TEMPLATE_PADRAO;
//   });

//   const salvarTemplate = (novoTemplate) => {
//     setTemplate(novoTemplate);
//     localStorage.setItem(STORAGE_KEY, novoTemplate);
//   };

//   const abrirModalWhatsApp = (parcela) => {
//     setParcelaSelecionada(parcela);
//     setShowModalWhatsApp(true);
//   };

//   const abrirModalTemplate = () => {
//     setShowModalWhatsApp(false);
//     setShowModalTemplate(true);
//   };

//   const fecharTemplate = () => {
//     setShowModalTemplate(false);
//     setShowModalWhatsApp(true); // volta pro modal do WhatsApp
//   };

//   const coresPlanos = ['#4361ee', '#3f37c9', '#7209b7', '#f72585', '#4cc9f0', '#f8961e', '#6c757d'];

//   const formatarMoeda = (valor) =>
//     new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor || 0);

//   const formatarData = (dataString) => {
//     if (!dataString) return '-';
//     return new Date(dataString).toLocaleDateString('pt-BR', { timeZone: 'UTC' });
//   };

//   const calcularDiferencaDias = (dataVencimento) => {
//     if (!dataVencimento) return null;
//     const hoje = new Date();
//     hoje.setHours(0, 0, 0, 0);
//     const vencimento = new Date(dataVencimento);
//     vencimento.setUTCHours(0, 0, 0, 0);
//     return Math.round((vencimento.getTime() - hoje.getTime()) / (1000 * 60 * 60 * 24));
//   };

//   const anoAnterior = () => setAnoSelecionado(prev => Math.max(prev - 1, 2020));
//   const anoProximo  = () => setAnoSelecionado(prev => Math.min(prev + 1, anoAtual));

//   const fetchDadosDashboard = async () => {
//     try {
//       setLoading(true);
//       setError('');
//       const response = await api.get('/dashboard', {
//         params: { meses: periodoGrafico, ano: anoSelecionado }
//       });
//       const data = response.data;
//       const planDistributionComCores = data.charts.planDistribution.map((item, index) => ({
//         ...item,
//         cor: coresPlanos[index % coresPlanos.length]
//       }));
//       setDashboardData({
//         ...data,
//         charts: { ...data.charts, planDistribution: planDistributionComCores }
//       });
//     } catch (err) {
//       toast.error('Erro ao carregar dados do dashboard');
//       setError('Não foi possível carregar os indicadores.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => { fetchDadosDashboard(); }, [periodoGrafico, anoSelecionado]);

//   useEffect(() => {
//     if (anoSelecionado !== anoAtual) return;
//     const interval = setInterval(fetchDadosDashboard, 5 * 60 * 1000);
//     return () => clearInterval(interval);
//   }, [periodoGrafico, anoSelecionado]);

//   useEffect(() => {
//     const handleResize = () => setWindowWidth(window.innerWidth);
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const parcelasFiltradas = React.useMemo(() => {
//     const parcelas = dashboardData.table.installments || [];
//     return parcelas.filter(parcela => {
//       const diff = calcularDiferencaDias(parcela.dueDate);
//       switch (filtroVencimento) {
//         case 'vence_hoje':    return diff === 0;
//         case 'vence_amanha':  return diff === 1;
//         case 'vencidos':      return diff < 0;
//         case 'proximos_dias': return diff >= 0 && diff <= diasPersonalizados;
//         default: return false;
//       }
//     }).slice(0, 15);
//   }, [dashboardData.table.installments, filtroVencimento, diasPersonalizados]);

//   const contadores = React.useMemo(() => {
//     const parcelas = dashboardData.table.installments || [];
//     return {
//       vence_hoje:    parcelas.filter(p => calcularDiferencaDias(p.dueDate) === 0).length,
//       vence_amanha:  parcelas.filter(p => calcularDiferencaDias(p.dueDate) === 1).length,
//       vencidos:      parcelas.filter(p => calcularDiferencaDias(p.dueDate) < 0).length,
//       proximos_dias: parcelas.filter(p => {
//         const d = calcularDiferencaDias(p.dueDate);
//         return d >= 0 && d <= diasPersonalizados;
//       }).length
//     };
//   }, [dashboardData.table.installments, diasPersonalizados]);

//   const getStatsGridColumns = () => {
//     if (windowWidth < 576) return 1;
//     if (windowWidth < 992) return 2;
//     return 4;
//   };

//   return (
//     <div className="page-content">
//       {error && <div className="alert alert-warning">{error}</div>}

//       {/* ── MODAIS ── */}
//       <ModalWhatsApp
//         show={showModalWhatsApp}
//         onClose={() => setShowModalWhatsApp(false)}
//         parcela={parcelaSelecionada}
//         template={template}
//         onAbrirTemplate={abrirModalTemplate}
//         formatarData={formatarData}
//         formatarMoeda={formatarMoeda}
//       />

//       <ModalEditarTemplate
//         show={showModalTemplate}
//         onClose={fecharTemplate}
//         template={template}
//         onSalvar={salvarTemplate}
//       />

//       {/* ── 1. CARDS KPI ── */}
//       <div className="stats-grid" style={{ gridTemplateColumns: `repeat(${getStatsGridColumns()}, 1fr)` }}>
//         {loading ? (
//           [1, 2, 3, 4].map(i => <SkeletonCard key={i} />)
//         ) : (
//           <>
//             <div className="stat-card">
//               <div className="stat-title">Saldo Total Recebido</div>
//               <div className="stat-value">{formatarMoeda(dashboardData.cards.saldo)}</div>
//             </div>
//             <div className="stat-card">
//               <div className="stat-title">Faturamento Mês Atual</div>
//               <div className="stat-value">{formatarMoeda(dashboardData.cards.faturamentoMes)}</div>
//             </div>
//             <div className="stat-card">
//               <div className="stat-title">Total de Clientes Ativos</div>
//               <div className="stat-value">{dashboardData.cards.clientesAtivos}</div>
//             </div>
//             <div className="stat-card">
//               <div className="stat-title">Contratos (Anúncios Ativos)</div>
//               <div className="stat-value">{dashboardData.cards.anunciosAtivos}</div>
//             </div>
//           </>
//         )}
//       </div>

//       {/* ── SELETOR DE PERÍODO + ANO ── */}
//       <div className="d-flex justify-content-between align-items-center mb-3 mt-2 flex-wrap gap-2">
//         <div className="d-flex align-items-center gap-2">
//           <small className="text-muted">Período:</small>
//           <ButtonGroup size="sm">
//             {[3, 6, 12].map(m => (
//               <Button
//                 key={m}
//                 variant={periodoGrafico === m ? 'primary' : 'outline-primary'}
//                 onClick={() => setPeriodoGrafico(m)}
//                 disabled={loading}
//               >
//                 {m} meses
//               </Button>
//             ))}
//           </ButtonGroup>
//         </div>

//         <div className="d-flex align-items-center gap-2">
//           <small className="text-muted">Ano:</small>
//           <div className="d-flex align-items-center border rounded overflow-hidden">
//             <Button variant="light" size="sm" onClick={anoAnterior} disabled={loading || anoSelecionado <= 2020} className="border-0 rounded-0 px-2">
//               <FaChevronLeft size={10} />
//             </Button>
//             <span className="px-3 py-1 fw-bold" style={{
//               fontSize: '14px',
//               backgroundColor: anoSelecionado === anoAtual ? '#4361ee' : '#f8961e',
//               color: '#fff', minWidth: '60px', textAlign: 'center'
//             }}>
//               {anoSelecionado}
//             </span>
//             <Button variant="light" size="sm" onClick={anoProximo} disabled={loading || anoSelecionado >= anoAtual} className="border-0 rounded-0 px-2">
//               <FaChevronRight size={10} />
//             </Button>
//           </div>
//           {anoSelecionado !== anoAtual && (
//             <Button variant="outline-secondary" size="sm" onClick={() => setAnoSelecionado(anoAtual)} disabled={loading}>
//               Hoje
//             </Button>
//           )}
//         </div>
//       </div>

//       {/* ── 2. GRÁFICOS ── */}
//       <div className={windowWidth < 992 ? '' : 'charts-grid'}>
//         <div className="card mb-3">
//           <div className="card-header"><h5 className="card-title mb-0">Evolução do Faturamento</h5></div>
//           <div className="card-body">
//             {loading ? <SkeletonChart /> : (
//               dashboardData.charts.monthlyEvolution.length > 0 ? (
//                 <ResponsiveContainer width="100%" height={300}>
//                   <ComposedChart data={dashboardData.charts.monthlyEvolution}>
//                     <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
//                     <XAxis dataKey="month" stroke="#6b7280" fontSize={12} />
//                     <YAxis stroke="#6b7280" fontSize={12} tickFormatter={(v) => `R$${(v / 1000).toFixed(0)}k`} />
//                     <Tooltip formatter={(value) => formatarMoeda(value)} />
//                     <Legend />
//                     <Bar dataKey="faturamento" fill="#4361ee" name="Faturamento" radius={[2, 2, 0, 0]} />
//                     <Bar dataKey="gastos"      fill="#f72585" name="Gastos"      radius={[2, 2, 0, 0]} />
//                     <Line type="monotone" dataKey="lucro" stroke="#4cc9f0" strokeWidth={3} name="Lucro" dot={{ r: 4 }} />
//                   </ComposedChart>
//                 </ResponsiveContainer>
//               ) : <div className="text-center py-5 text-muted">Nenhum dado encontrado.</div>
//             )}
//           </div>
//         </div>

//         <div className="card mb-3">
//           <div className="card-header"><h5 className="card-title mb-0">Controle Financeiro</h5></div>
//           <div className="card-body">
//             {loading ? <SkeletonChart /> : (
//               dashboardData.charts.financialControl.length > 0 ? (
//                 <ResponsiveContainer width="100%" height={300}>
//                   <BarChart data={dashboardData.charts.financialControl}>
//                     <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
//                     <XAxis dataKey="month" stroke="#6b7280" fontSize={12} />
//                     <YAxis stroke="#6b7280" fontSize={12} tickFormatter={(v) => `R$${(v / 1000).toFixed(0)}k`} />
//                     <Tooltip formatter={(value) => formatarMoeda(value)} />
//                     <Legend />
//                     <Bar dataKey="pago"         stackId="a" fill="#4361ee" name="Valor Pago" />
//                     <Bar dataKey="aReceber"     stackId="a" fill="#6b7280" name="A Receber" />
//                     <Bar dataKey="inadimplente" stackId="a" fill="#f72585" name="Inadimplência" />
//                   </BarChart>
//                 </ResponsiveContainer>
//               ) : <div className="text-center py-5 text-muted">Nenhum dado encontrado.</div>
//             )}
//           </div>
//         </div>
//       </div>

//       <div className={windowWidth < 992 ? '' : 'charts-grid'}>
//         <div className="card mb-3">
//           <div className="card-header"><h5 className="card-title mb-0">Distribuição por Planos</h5></div>
//           <div className="card-body">
//             {loading ? <SkeletonChart /> : (
//               dashboardData.charts.planDistribution.length > 0 ? (
//                 <ResponsiveContainer width="100%" minHeight={300}>
//                   <PieChart>
//                     <Pie data={dashboardData.charts.planDistribution} cx="50%" cy="50%" outerRadius="70%" dataKey="value" nameKey="name"
//                       label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}>
//                       {dashboardData.charts.planDistribution.map((entry, index) => (
//                         <Cell key={`cell-${index}`} fill={entry.cor} />
//                       ))}
//                     </Pie>
//                     <Tooltip />
//                     <Legend />
//                   </PieChart>
//                 </ResponsiveContainer>
//               ) : <div className="text-center py-5 text-muted">Nenhum plano ativo encontrado.</div>
//             )}
//           </div>
//         </div>

//         {/* ── TABELA DE PARCELAS ── */}
//         <div className="card mb-3">
//           <div className="card-header d-flex justify-content-between align-items-center">
//             <h5 className="card-title mb-0">Parcelas Pendentes / Vencidas</h5>
//             <Button variant="outline-primary" size="sm" onClick={fetchDadosDashboard} disabled={loading}>
//               <FaSync className={`me-1 ${loading ? 'fa-spin' : ''}`} /> Atualizar
//             </Button>
//           </div>
//           <div className="card-body">
//             <div className="mb-2">
//               <ButtonGroup size="sm" className="w-100">
//                 <Button variant={filtroVencimento === 'vence_hoje'    ? 'danger'     : 'outline-danger'}     onClick={() => setFiltroVencimento('vence_hoje')}>    Hoje ({contadores.vence_hoje})</Button>
//                 <Button variant={filtroVencimento === 'vence_amanha'  ? 'warning'    : 'outline-warning'}    onClick={() => setFiltroVencimento('vence_amanha')}>  Amanhã ({contadores.vence_amanha})</Button>
//                 <Button variant={filtroVencimento === 'vencidos'      ? 'secondary'  : 'outline-secondary'}  onClick={() => setFiltroVencimento('vencidos')}>      Vencidos ({contadores.vencidos})</Button>
//                 <Button variant={filtroVencimento === 'proximos_dias' ? 'info'       : 'outline-info'}       onClick={() => setFiltroVencimento('proximos_dias')}> Próx. dias ({contadores.proximos_dias})</Button>
//               </ButtonGroup>
//             </div>

//             {filtroVencimento === 'proximos_dias' && (
//               <div className="d-flex align-items-center gap-2 mb-3 mt-1">
//                 <small className="text-muted">Mostrar próximos:</small>
//                 <Form.Control type="number" size="sm" min={1} max={90} value={diasPersonalizados}
//                   onChange={(e) => setDiasPersonalizados(Number(e.target.value))} style={{ width: '75px' }} />
//                 <small className="text-muted">dias</small>
//               </div>
//             )}

//             <div className="table-responsive">
//               {loading ? <SkeletonTable /> : (
//                 parcelasFiltradas.length > 0 ? (
//                   <table className="table table-sm table-hover">
//                     <thead>
//                       <tr>
//                         <th>Cliente</th>
//                         <th>Contato</th>
//                         <th>Parcela</th>
//                         <th>Valor</th>
//                         <th>Vencimento</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {parcelasFiltradas.map((parcela) => (
//                         <tr key={parcela.id} className={parcela.status === 'OVERDUE' ? 'table-danger' : ''}>
//                           <td>{parcela.customerName}</td>
//                           <td>
//                             {parcela.phone ? (
//                               // ✅ Agora abre o modal em vez de ir direto pro WhatsApp
//                               <button
//                                 className="btn btn-success btn-sm py-0 px-2"
//                                 onClick={() => abrirModalWhatsApp(parcela)}
//                                 title={`Contatar ${parcela.customerName}`}
//                               >
//                                 <FaWhatsapp className="me-1" />
//                                 <small>WhatsApp</small>
//                               </button>
//                             ) : (
//                               <small className="text-muted">-</small>
//                             )}
//                           </td>
//                           <td>{parcela.installmentNumber}ª</td>
//                           <td><strong>{formatarMoeda(parcela.amount)}</strong></td>
//                           <td><small>{formatarData(parcela.dueDate)}</small></td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 ) : (
//                   <div className="text-center py-4 text-muted">
//                     Nenhuma parcela encontrada para o filtro selecionado.
//                   </div>
//                 )
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Dashboard;


import React, { useState, useEffect, useCallback } from 'react';
import { Button, ButtonGroup, Form, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaSpinner, FaSync, FaWhatsapp, FaChevronLeft, FaChevronRight, FaEdit } from 'react-icons/fa';
import {
  BarChart, Bar, Line, PieChart, Pie, Cell,
  XAxis, YAxis, CartesianGrid, Tooltip, Legend,
  ResponsiveContainer, ComposedChart
} from 'recharts';
import { toast } from 'react-toastify';
import '../../responsive.css';
import api from '../../services/api';

// ==========================================
// TEMPLATE PADRÃO
// ==========================================
const TEMPLATE_PADRAO = `Olá, \${CLIENTE}. Tudo bem com você? Segue o link do boleto da \${EMPRESA} com o vencimento para \${VENCIMENTO}. Caso já tenha pago, desconsidere essa mensagem.
Link: \${LINK_BOLETO}
Se preferir fazer o PIX, essa é nossa chave: SEU_PIX_AQUI`;

const STORAGE_KEY = 'whatsapp_template';

// ==========================================
// SKELETON LOADING COMPONENTS
// ==========================================
const SkeletonCard = () => (
  <div className="stat-card">
    <div className="placeholder-glow">
      <span className="placeholder col-7 mb-2 d-block" style={{ height: '14px', borderRadius: '4px' }}></span>
      <span className="placeholder col-10 d-block" style={{ height: '32px', borderRadius: '4px' }}></span>
    </div>
  </div>
);

const SkeletonChart = () => (
  <div className="placeholder-glow p-3" style={{ height: '300px', display: 'flex', alignItems: 'flex-end', gap: '12px' }}>
    {[40, 70, 55, 90, 65, 80, 45, 75, 60, 85, 50, 95].map((h, i) => (
      <span key={i} className="placeholder flex-fill" style={{ height: `${h}%`, borderRadius: '4px 4px 0 0' }}></span>
    ))}
  </div>
);

const SkeletonTable = () => (
  <div className="placeholder-glow">
    {[1, 2, 3, 4, 5].map(i => (
      <div key={i} className="d-flex gap-3 mb-3">
        <span className="placeholder col-4" style={{ height: '18px', borderRadius: '4px' }}></span>
        <span className="placeholder col-2" style={{ height: '18px', borderRadius: '4px' }}></span>
        <span className="placeholder col-2" style={{ height: '18px', borderRadius: '4px' }}></span>
        <span className="placeholder col-2" style={{ height: '18px', borderRadius: '4px' }}></span>
      </div>
    ))}
  </div>
);

// ==========================================
// MODAL: EDITAR TEMPLATE
// ==========================================
const ModalEditarTemplate = ({ show, onClose, template, onSalvar }) => {
  const [texto, setTexto] = useState(template);

  useEffect(() => {
    setTexto(template);
  }, [template]);

  const handleSalvar = () => {
    onSalvar(texto);
    onClose();
    toast.success('Template salvo com sucesso!');
  };

  const handleRestaurar = () => {
    setTexto(TEMPLATE_PADRAO);
  };

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Editar Template</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="alert alert-info mb-3" style={{ borderLeft: '4px solid #4361ee', borderRadius: '6px' }}>
          <strong>Importante!</strong>
          <ul className="mb-0 mt-2">
            <li><code>{'${CLIENTE}'}</code> — nome do cliente</li>
            <li><code>{'${VENCIMENTO}'}</code> — vencimento da parcela</li>
            <li><code>{'${PARCELA}'}</code> — ex: "02 de 12"</li>
            <li><code>{'${VALOR}'}</code> — valor da parcela</li>
            <li><code>{'${EMPRESA}'}</code> — nome da sua empresa</li>
            <li><code>{'${LINK_BOLETO}'}</code> — link do boleto</li>
          </ul>
        </div>

        <Form.Group>
          <Form.Label className="fw-bold">Mensagem</Form.Label>
          <Form.Control
            as="textarea"
            rows={8}
            value={texto}
            onChange={(e) => setTexto(e.target.value)}
            placeholder="Digite o template da mensagem..."
          />
          <Form.Text className="text-muted">{texto.length}/600</Form.Text>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer className="justify-content-between">
        <Button variant="outline-secondary" onClick={handleRestaurar}>
          Restaurar padrão
        </Button>
        <div className="d-flex gap-2">
          <Button variant="outline-dark" onClick={onClose}>Fechar</Button>
          <Button variant="success" onClick={handleSalvar}>Salvar</Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

// ==========================================
// MODAL: ENVIAR WHATSAPP
// ==========================================
const ModalWhatsApp = ({ show, onClose, parcela, template, onAbrirTemplate, formatarData, formatarMoeda }) => {
  const [telefone, setTelefone] = useState('');
  const [mensagem, setMensagem] = useState('');

  const gerarMensagem = useCallback((tpl) => {
    const nomeEmpresa = localStorage.getItem('empresa_nome') || 'nossa empresa';

    return tpl
      .replace(/\${CLIENTE}/g,    parcela?.customerName   || '')
      .replace(/\${VENCIMENTO}/g, parcela?.dueDate
        ? new Date(parcela.dueDate).toLocaleDateString('pt-BR', { timeZone: 'UTC' })
        : '')
      .replace(/\${PARCELA}/g,    parcela?.installmentNumber
        ? `${String(parcela.installmentNumber).padStart(2, '0')} de ${String(parcela.totalInstallments || '?').padStart(2, '0')}`
        : '')
      .replace(/\${VALOR}/g,      parcela?.amount
        ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(parcela.amount)
        : '')
      .replace(/\${EMPRESA}/g,    nomeEmpresa)
      .replace(/\${LINK_BOLETO}/g, parcela?.boletoUrl || '');
  }, [parcela]);

  useEffect(() => {
    if (parcela) {
      const num = (parcela.phone || '').replace(/\D/g, '');
      setTelefone(num.startsWith('55') ? num : `55${num}`);
      setMensagem(gerarMensagem(template));
    }
  }, [parcela, template, gerarMensagem]);

  const handleEnviar = () => {
    if (!telefone) {
      toast.warning('Informe o telefone!');
      return;
    }
    const url = `https://wa.me/${telefone}?text=${encodeURIComponent(mensagem)}`;
    window.open(url, '_blank');
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <FaWhatsapp className="me-2 text-success" />
          Enviar boleto via WhatsApp
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {parcela && (
          <div className="mb-3 p-2 bg-light rounded">
            <div>
              <strong>Conta:</strong>{' '}
              <span className="text-danger">{parcela.orderDescription || parcela.customerName}</span>
            </div>
            <div>
              <strong>Parcela:</strong>{' '}
              <span className="text-danger">
                {String(parcela.installmentNumber || '').padStart(2, '0')} de{' '}
                {String(parcela.totalInstallments || '?').padStart(2, '0')}
              </span>
            </div>
          </div>
        )}

        <Form.Group className="mb-3">
          <Form.Label className="fw-bold">Telefone:</Form.Label>
          <div className="input-group">
            <span className="input-group-text text-success">
              <FaWhatsapp />
            </span>
            <Form.Control
              type="text"
              value={telefone}
              onChange={(e) => setTelefone(e.target.value.replace(/\D/g, ''))}
              placeholder="5588999999999"
            />
          </div>
        </Form.Group>

        <Form.Group>
          <Form.Label className="fw-bold">Mensagem:</Form.Label>
          <Form.Control
            as="textarea"
            rows={7}
            value={mensagem}
            onChange={(e) => setMensagem(e.target.value)}
          />
          <Form.Text className="text-muted">{mensagem.length}/600</Form.Text>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer className="justify-content-between">
        <Button variant="dark" onClick={onAbrirTemplate}>
          <FaEdit className="me-1" /> Template
        </Button>
        <div className="d-flex gap-2">
          <Button variant="outline-dark" onClick={onClose}>Fechar</Button>
          <Button variant="success" onClick={handleEnviar}>
            <FaWhatsapp className="me-1" /> Enviar
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

// ==========================================
// COMPONENTE PRINCIPAL
// ==========================================
const Dashboard = () => {
  const navigate = useNavigate();
  const anoAtual = new Date().getFullYear();

  const [windowWidth, setWindowWidth]       = useState(window.innerWidth);
  const [loading, setLoading]               = useState(true);
  const [error, setError]                   = useState('');
  const [periodoGrafico, setPeriodoGrafico] = useState(6);
  const [anoSelecionado, setAnoSelecionado] = useState(anoAtual);

  const [dashboardData, setDashboardData] = useState({
    cards: {
      saldo: 0,
      faturamentoMes: 0,
      clientesAtivos: 0,
      anunciosAtivos: 0,
      pedidosVencendo: 0
    },
    charts: { monthlyEvolution: [], financialControl: [], planDistribution: [] },
    table: { installments: [] }
  });

  const [filtroVencimento, setFiltroVencimento]     = useState('vencidos');
  const [diasPersonalizados, setDiasPersonalizados] = useState(7);

  const [parcelaSelecionada, setParcelaSelecionada]       = useState(null);
  const [showModalWhatsApp, setShowModalWhatsApp]         = useState(false);
  const [showModalTemplate, setShowModalTemplate]         = useState(false);

  const [template, setTemplate] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) || TEMPLATE_PADRAO;
  });

  const salvarTemplate = (novoTemplate) => {
    setTemplate(novoTemplate);
    localStorage.setItem(STORAGE_KEY, novoTemplate);
  };

  const abrirModalWhatsApp = (parcela) => {
    setParcelaSelecionada(parcela);
    setShowModalWhatsApp(true);
  };

  const abrirModalTemplate = () => {
    setShowModalWhatsApp(false);
    setShowModalTemplate(true);
  };

  const fecharTemplate = () => {
    setShowModalTemplate(false);
    setShowModalWhatsApp(true);
  };

  const coresPlanos = ['#4361ee', '#3f37c9', '#7209b7', '#f72585', '#4cc9f0', '#f8961e', '#6c757d'];

  const formatarMoeda = (valor) =>
    new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor || 0);

  const formatarData = (dataString) => {
    if (!dataString) return '-';
    return new Date(dataString).toLocaleDateString('pt-BR', { timeZone: 'UTC' });
  };

  // 🔧 Formatador de eixo Y dos gráficos (CORRIGIDO!)
  const formatarEixoY = (valor) => {
    if (valor >= 1000) {
      return `R$ ${(valor / 1000).toFixed(0)}k`;
    }
    return `R$ ${valor}`;
  };

  const calcularDiferencaDias = (dataVencimento) => {
    if (!dataVencimento) return null;
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    const vencimento = new Date(dataVencimento);
    vencimento.setUTCHours(0, 0, 0, 0);
    return Math.round((vencimento.getTime() - hoje.getTime()) / (1000 * 60 * 60 * 24));
  };

  const anoAnterior = () => setAnoSelecionado(prev => Math.max(prev - 1, 2020));
  const anoProximo  = () => setAnoSelecionado(prev => Math.min(prev + 1, anoAtual));

  const fetchDadosDashboard = async () => {
    try {
      setLoading(true);
      setError('');
      const response = await api.get('/dashboard', {
        params: { meses: periodoGrafico, ano: anoSelecionado }
      });
      const data = response.data;
      const planDistributionComCores = data.charts.planDistribution.map((item, index) => ({
        ...item,
        cor: coresPlanos[index % coresPlanos.length]
      }));
      setDashboardData({
        ...data,
        charts: { ...data.charts, planDistribution: planDistributionComCores }
      });
    } catch (err) {
      toast.error('Erro ao carregar dados do dashboard');
      setError('Não foi possível carregar os indicadores.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchDadosDashboard(); }, [periodoGrafico, anoSelecionado]);

  useEffect(() => {
    if (anoSelecionado !== anoAtual) return;
    const interval = setInterval(fetchDadosDashboard, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, [periodoGrafico, anoSelecionado]);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const parcelasFiltradas = React.useMemo(() => {
    const parcelas = dashboardData.table.installments || [];
    return parcelas.filter(parcela => {
      const diff = calcularDiferencaDias(parcela.dueDate);
      switch (filtroVencimento) {
        case 'vence_hoje':    return diff === 0;
        case 'vence_amanha':  return diff === 1;
        case 'vencidos':      return diff < 0;
        case 'proximos_dias': return diff >= 0 && diff <= diasPersonalizados;
        default: return false;
      }
    }).slice(0, 15);
  }, [dashboardData.table.installments, filtroVencimento, diasPersonalizados]);

  const contadores = React.useMemo(() => {
    const parcelas = dashboardData.table.installments || [];
    return {
      vence_hoje:    parcelas.filter(p => calcularDiferencaDias(p.dueDate) === 0).length,
      vence_amanha:  parcelas.filter(p => calcularDiferencaDias(p.dueDate) === 1).length,
      vencidos:      parcelas.filter(p => calcularDiferencaDias(p.dueDate) < 0).length,
      proximos_dias: parcelas.filter(p => {
        const d = calcularDiferencaDias(p.dueDate);
        return d >= 0 && d <= diasPersonalizados;
      }).length
    };
  }, [dashboardData.table.installments, diasPersonalizados]);

  const getStatsGridColumns = () => {
    if (windowWidth < 576)  return 1;
    if (windowWidth < 768)  return 2;
    if (windowWidth < 1200) return 3;
    return 5;
  };

  return (
    <div className="page-content">
      {error && <div className="alert alert-warning">{error}</div>}

      {/* ── MODAIS ── */}
      <ModalWhatsApp
        show={showModalWhatsApp}
        onClose={() => setShowModalWhatsApp(false)}
        parcela={parcelaSelecionada}
        template={template}
        onAbrirTemplate={abrirModalTemplate}
        formatarData={formatarData}
        formatarMoeda={formatarMoeda}
      />

      <ModalEditarTemplate
        show={showModalTemplate}
        onClose={fecharTemplate}
        template={template}
        onSalvar={salvarTemplate}
      />

      {/* ── 1. CARDS KPI (5 cards) ── */}
      <div className="stats-grid" style={{ gridTemplateColumns: `repeat(${getStatsGridColumns()}, 1fr)` }}>
        {loading ? (
          [1, 2, 3, 4, 5].map(i => <SkeletonCard key={i} />)
        ) : (
          <>
            {/* 💰 Saldo (não clicável) */}
            <div className="stat-card">
              <div className="stat-title">Saldo Total Recebido</div>
              <div className="stat-value">{formatarMoeda(dashboardData.cards.saldo)}</div>
            </div>

            {/* 📈 Faturamento Mês (não clicável) */}
            <div className="stat-card">
              <div className="stat-title">Faturamento Mês Atual</div>
              <div className="stat-value">{formatarMoeda(dashboardData.cards.faturamentoMes)}</div>
            </div>

            {/* 👥 Clientes → /clientes */}
            <div
              className="stat-card stat-card-clickable"
              onClick={() => navigate('/clientes')}
              style={{ cursor: 'pointer' }}
              title="Ver todos os clientes"
            >
              <div className="stat-title">Total de Clientes Ativos</div>
              <div className="stat-value">{dashboardData.cards.clientesAtivos}</div>
            </div>

            {/* 📺 Anúncios → /pedidos?status=ATIVO */}
            <div
              className="stat-card stat-card-clickable"
              onClick={() => navigate('/pedidos?status=ATIVO')}
              style={{ cursor: 'pointer' }}
              title="Ver pedidos ativos"
            >
              <div className="stat-title">Contratos (Anúncios Ativos)</div>
              <div className="stat-value">{dashboardData.cards.anunciosAtivos}</div>
            </div>

            {/* ⏰ Pedidos a Vencer → /relatorios/contratos-expirando */}
            <div
              className="stat-card stat-card-clickable"
              onClick={() => navigate('/relatorios/contratos-expirando')}
              style={{ cursor: 'pointer' }}
              title="Ver contratos expirando"
            >
              <div className="stat-title">
                Pedidos a Vencer (30 dias)
                {dashboardData.cards.pedidosVencendo > 0 && (
                  <span className="badge bg-warning ms-2" style={{ fontSize: '10px' }}>⚠️</span>
                )}
              </div>
              <div className="stat-value">{dashboardData.cards.pedidosVencendo || 0}</div>
            </div>
          </>
        )}
      </div>

      {/* ── SELETOR DE PERÍODO + ANO ── */}
      <div className="d-flex justify-content-between align-items-center mb-3 mt-2 flex-wrap gap-2">
        <div className="d-flex align-items-center gap-2">
          <small className="text-muted">Período:</small>
          <ButtonGroup size="sm">
            {[3, 6, 12].map(m => (
              <Button
                key={m}
                variant={periodoGrafico === m ? 'primary' : 'outline-primary'}
                onClick={() => setPeriodoGrafico(m)}
                disabled={loading}
              >
                {m} meses
              </Button>
            ))}
          </ButtonGroup>
        </div>

        <div className="d-flex align-items-center gap-2">
          <small className="text-muted">Ano:</small>
          <div className="d-flex align-items-center border rounded overflow-hidden">
            <Button variant="light" size="sm" onClick={anoAnterior} disabled={loading || anoSelecionado <= 2020} className="border-0 rounded-0 px-2">
              <FaChevronLeft size={10} />
            </Button>
            <span className="px-3 py-1 fw-bold" style={{
              fontSize: '14px',
              backgroundColor: anoSelecionado === anoAtual ? '#4361ee' : '#f8961e',
              color: '#fff', minWidth: '60px', textAlign: 'center'
            }}>
              {anoSelecionado}
            </span>
            <Button variant="light" size="sm" onClick={anoProximo} disabled={loading || anoSelecionado >= anoAtual} className="border-0 rounded-0 px-2">
              <FaChevronRight size={10} />
            </Button>
          </div>
          {anoSelecionado !== anoAtual && (
            <Button variant="outline-secondary" size="sm" onClick={() => setAnoSelecionado(anoAtual)} disabled={loading}>
              Hoje
            </Button>
          )}
        </div>
      </div>

      {/* ── 2. GRÁFICOS ── */}
      <div className={windowWidth < 992 ? '' : 'charts-grid'}>
        <div className="card mb-3">
          <div className="card-header"><h5 className="card-title mb-0">Evolução do Faturamento</h5></div>
          <div className="card-body">
            {loading ? <SkeletonChart /> : (
              dashboardData.charts.monthlyEvolution.length > 0 ? (
                <ResponsiveContainer width="100%" height={300}>
                  <ComposedChart data={dashboardData.charts.monthlyEvolution}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                    <XAxis dataKey="month" stroke="#6b7280" fontSize={12} />
                    <YAxis stroke="#6b7280" fontSize={12} tickFormatter={formatarEixoY} />
                    <Tooltip formatter={(value) => formatarMoeda(value)} />
                    <Legend />
                    <Bar dataKey="faturamento" fill="#4361ee" name="Faturamento" radius={[2, 2, 0, 0]} />
                    <Bar dataKey="gastos"      fill="#f72585" name="Gastos"      radius={[2, 2, 0, 0]} />
                    <Line type="monotone" dataKey="lucro" stroke="#4cc9f0" strokeWidth={3} name="Lucro" dot={{ r: 4 }} />
                  </ComposedChart>
                </ResponsiveContainer>
              ) : <div className="text-center py-5 text-muted">Nenhum dado encontrado.</div>
            )}
          </div>
        </div>

        <div className="card mb-3">
          <div className="card-header"><h5 className="card-title mb-0">Controle Financeiro</h5></div>
          <div className="card-body">
            {loading ? <SkeletonChart /> : (
              dashboardData.charts.financialControl.length > 0 ? (
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart data={dashboardData.charts.financialControl}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                    <XAxis dataKey="month" stroke="#6b7280" fontSize={12} />
                    <YAxis stroke="#6b7280" fontSize={12} tickFormatter={formatarEixoY} />
                    <Tooltip formatter={(value) => formatarMoeda(value)} />
                    <Legend />
                    <Bar dataKey="pago"         stackId="a" fill="#4361ee" name="Valor Pago" />
                    <Bar dataKey="aReceber"     stackId="a" fill="#6b7280" name="A Receber" />
                    <Bar dataKey="inadimplente" stackId="a" fill="#f72585" name="Inadimplência" />
                  </BarChart>
                </ResponsiveContainer>
              ) : <div className="text-center py-5 text-muted">Nenhum dado encontrado.</div>
            )}
          </div>
        </div>
      </div>

      <div className={windowWidth < 992 ? '' : 'charts-grid'}>
        <div className="card mb-3">
          <div className="card-header"><h5 className="card-title mb-0">Distribuição por Planos</h5></div>
          <div className="card-body">
            {loading ? <SkeletonChart /> : (
              dashboardData.charts.planDistribution.length > 0 ? (
                <ResponsiveContainer width="100%" minHeight={300}>
                  <PieChart>
                    <Pie data={dashboardData.charts.planDistribution} cx="50%" cy="50%" outerRadius="70%" dataKey="value" nameKey="name"
                      label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}>
                      {dashboardData.charts.planDistribution.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.cor} />
                      ))}
                    </Pie>
                    <Tooltip />
                    <Legend />
                  </PieChart>
                </ResponsiveContainer>
              ) : <div className="text-center py-5 text-muted">Nenhum plano ativo encontrado.</div>
            )}
          </div>
        </div>

        {/* ── TABELA DE PARCELAS ── */}
        <div className="card mb-3">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h5 className="card-title mb-0">Parcelas Pendentes / Vencidas</h5>
            <Button variant="outline-primary" size="sm" onClick={fetchDadosDashboard} disabled={loading}>
              <FaSync className={`me-1 ${loading ? 'fa-spin' : ''}`} /> Atualizar
            </Button>
          </div>
          <div className="card-body">
            <div className="mb-2">
              <ButtonGroup size="sm" className="w-100">
                <Button variant={filtroVencimento === 'vence_hoje'    ? 'danger'     : 'outline-danger'}     onClick={() => setFiltroVencimento('vence_hoje')}>    Hoje ({contadores.vence_hoje})</Button>
                <Button variant={filtroVencimento === 'vence_amanha'  ? 'warning'    : 'outline-warning'}    onClick={() => setFiltroVencimento('vence_amanha')}>  Amanhã ({contadores.vence_amanha})</Button>
                <Button variant={filtroVencimento === 'vencidos'      ? 'secondary'  : 'outline-secondary'}  onClick={() => setFiltroVencimento('vencidos')}>      Vencidos ({contadores.vencidos})</Button>
                <Button variant={filtroVencimento === 'proximos_dias' ? 'info'       : 'outline-info'}       onClick={() => setFiltroVencimento('proximos_dias')}> Próx. dias ({contadores.proximos_dias})</Button>
              </ButtonGroup>
            </div>

            {filtroVencimento === 'proximos_dias' && (
              <div className="d-flex align-items-center gap-2 mb-3 mt-1">
                <small className="text-muted">Mostrar próximos:</small>
                <Form.Control type="number" size="sm" min={1} max={90} value={diasPersonalizados}
                  onChange={(e) => setDiasPersonalizados(Number(e.target.value))} style={{ width: '75px' }} />
                <small className="text-muted">dias</small>
              </div>
            )}

            <div className="table-responsive">
              {loading ? <SkeletonTable /> : (
                parcelasFiltradas.length > 0 ? (
                  <table className="table table-sm table-hover">
                    <thead>
                      <tr>
                        <th>Cliente</th>
                        <th>Contato</th>
                        <th>Parcela</th>
                        <th>Valor</th>
                        <th>Vencimento</th>
                      </tr>
                    </thead>
                    <tbody>
                      {parcelasFiltradas.map((parcela) => (
                        <tr key={parcela.id} className={parcela.status === 'OVERDUE' ? 'table-danger' : ''}>
                          <td>{parcela.customerName}</td>
                          <td>
                            {parcela.phone ? (
                              <button
                                className="btn btn-success btn-sm py-0 px-2"
                                onClick={() => abrirModalWhatsApp(parcela)}
                                title={`Contatar ${parcela.customerName}`}
                              >
                                <FaWhatsapp className="me-1" />
                                <small>WhatsApp</small>
                              </button>
                            ) : (
                              <small className="text-muted">-</small>
                            )}
                          </td>
                          <td>{parcela.installmentNumber}ª</td>
                          <td><strong>{formatarMoeda(parcela.amount)}</strong></td>
                          <td><small>{formatarData(parcela.dueDate)}</small></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="text-center py-4 text-muted">
                    Nenhuma parcela encontrada para o filtro selecionado.
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
